import { toRefs, ref, computed, watch, onBeforeUnmount } from 'vue';
import Input from './component-lib.esm2.js';
import IconButton from '../../components/icon-button/component-lib.esm.js';
import SmileOIcon from '../../icons/component-lib.esm39.js';
import { InputProps } from './component-lib.esm4.js';
import { useModel } from '../../compositions/component-lib.esm15.js';

//
var script = {
  name: 'EmojiInput',
  components: {
    Input,
    IconButton,
    SmileOIcon
  },
  props: {
    ...InputProps,
    showEmoji: {
      type: Boolean,
      default: true
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const showPicker = ref(false);
    const isLoading = ref(false);
    const emojiButton = ref(null);
    const picker = ref(null);
    const trigger = ref(null);
    const input = ref(null);
    const selectionStart = ref(0);
    const selectionEnd = ref(0);
    const localValue = useModel(value, val => emit('input', val));
    if (localValue.value) selectionEnd.value = selectionStart.value = localValue.value.length;
    const inputEl = computed(() => {
      if (input.value) return input.value.$el.querySelector('input');
      return null;
    });
    async function loadEmojiLib() {
      isLoading.value = true;
      const {
        EmojiButton
      } = await import('../../external/@joeattardi/emoji-button/dist/component-lib.esm.js');
      emojiButton.value = EmojiButton;
      isLoading.value = false;
    }
    function addPickerEvents() {
      picker.value.on('emoji', selection => {
        let value = localValue.value || '';
        localValue.value = `${value.slice(0, selectionStart.value)}${selection.emoji}${value.slice(selectionEnd.value)}`;
      });
      picker.value.on('hidden', () => showPicker.value = false);
    }
    function setSelection() {
      selectionStart.value = inputEl.value.selectionStart;
      selectionEnd.value = inputEl.value.selectionEnd;
    }
    watch(showPicker, async value => {
      if (value && !emojiButton.value) {
        await loadEmojiLib();
        picker.value = new emojiButton.value();
        addPickerEvents();
      }
      if (value) picker.value.showPicker(trigger.value.$el);else picker.value.hidePicker();
    });
    onBeforeUnmount(() => {
      if (picker.value) picker.value.destroyPicker();
    });
    function focus() {
      input.value.focus();
    }
    return {
      showPicker,
      isLoading,
      localValue,
      trigger,
      setSelection,
      input,
      focus
    };
  }
};
export { script as default };